/* eslint-disable no-console */
// React
import { useState, useCallback } from "react";

const useAudioRecording = () => {
	const [isRecording, setIsRecording] = useState(false);
	const [isPaused, setIsPaused] = useState(false);
	const [recordingTime, setRecordingTime] = useState(0);
	const [timerInterval, setTimerInterval] = useState(null);
	const [mediaRecorder, setMediaRecorder] = useState(undefined);
	const [recordingBlob, setRecordingBlob] = useState(undefined);

	const startTimer = useCallback(() => {
		const interval = setInterval(() => {
			setRecordingTime((time) => {
				return time + 1;
			});
		}, 1000);
		setTimerInterval(interval);
	}, [setRecordingTime, setTimerInterval]);

	const stopTimer = useCallback(() => {
		if (timerInterval !== null) {
			clearInterval(timerInterval);
		}
		setTimerInterval(null);
	}, [timerInterval, setTimerInterval]);

	const startRecording = useCallback(() => {
		if (timerInterval !== null) return;
		navigator.mediaDevices
			.getUserMedia({ audio: true })
			.then((stream) => {
				setIsRecording(true);
				const recorder = new MediaRecorder(stream, { mimeType: "audio/webm" });
				setMediaRecorder(recorder);
				recorder.start();
				startTimer();

				recorder.addEventListener("dataavailable", (event) => {
					setRecordingBlob(event.data);
					recorder.stream.getTracks().forEach((t) => {
						return t.stop();
					});
					setMediaRecorder(undefined);
				});
			})
			.catch((err) => {
				return console.log(err);
			});
	}, [timerInterval, setIsRecording, setMediaRecorder, startTimer, setRecordingBlob]);

	const stopRecording = useCallback(() => {
		mediaRecorder?.stop();
		stopTimer();
		setRecordingTime(0);
		setIsRecording(false);
		setIsPaused(false);
	}, [mediaRecorder, setRecordingTime, setIsRecording, setIsPaused, stopTimer]);

	const togglePauseResume = useCallback(() => {
		if (isPaused) {
			setIsPaused(false);
			mediaRecorder?.resume();
			startTimer();
		} else {
			setIsPaused(true);
			stopTimer();
			mediaRecorder?.pause();
		}
	}, [mediaRecorder, setIsPaused, startTimer, stopTimer]);

	return {
		startRecording,
		stopRecording,
		togglePauseResume,
		recordingBlob,
		isRecording,
		isPaused,
		recordingTime,
		mediaRecorder,
		setRecordingBlob,
	};
};

export default useAudioRecording;
